export default __webpack_public_path__ + "261e69772288725d6d34381fa28c3105.svg";